import React from 'react';

const Message = () => {
  return (
    <div id="message" className="container">
      <div className="content">
        <h2>CREATOR'S NOTE</h2>
        <blockquote>"Our Anti-bullying Clothing Line aims to discourage bullying and foster kindness one T-shirt at a time. At the same time we want to help parents raise safe, confident and happy kids through our products, and initiatives."</blockquote>
        <h3>~ <a href="http://www.gladyshenriquez.com" target="_blank">Gladys Henriquez</a>, Creator of AnitBully Clothing</h3>
      </div>
    </div>
  )
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/home/Message.js